import SearchSelector from './components/searchSelector';

const install = function(Vue) {
    if (install.installed) return;
    Vue.component('SearchSelector', SearchSelector);

};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

const API = {
    version: process.env.VERSION, // eslint-disable-line no-undef
    install,
    SearchSelector
};

module.exports.default = module.exports = API;   // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./src/index.js